import cx from "classnames"
import { camelize } from "../../utils"
import type { IconColorsType } from "../"
export type IconProps = {
  color?: IconColorsType
  size?: 16 | 20 | 24 | 32
  contained?: boolean
  className?: string
}
const iconSource = "airportFilled"
const AirportFilledIcon = ({
  color,
  size = 24,
  contained = false,
  className,
}: IconProps) => {
  const computedClassName = cx(
    className,
    `cobalt-Icon cobalt-Icon--${iconSource}`,
    {
      [`c-fill-${camelize(color || "")}`]: color,
      "cobalt-Icon--size16": size === 16,
      "cobalt-Icon--size20": size === 20,
      "cobalt-Icon--size32": size === 32,
      "cobalt-Icon--contained": contained,
    },
  )
  return (
    <span className={computedClassName}>
      {
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
          <title>{iconSource}</title>
          <path d="M5.25 15C6.493 15 7.5 16.007 7.5 17.25S6.493 19.5 5.25 19.5C4.008 19.5 3 18.493 3 17.25S4.008 15 5.25 15M18.75 15C19.993 15 21 16.007 21 17.25S19.993 19.5 18.75 19.5C17.508 19.5 16.5 18.493 16.5 17.25S17.508 15 18.75 15" />
          <path
            fillRule="evenodd"
            d="M12 3C12.415 3 12.75 3.336 12.75 3.75V7.743C14.981 8.075 16.735 9.861 17.02 12.107L22.682 13.523C23.084 13.623 23.328 14.03 23.228 14.432 23.128 14.833 22.72 15.078 22.318 14.977L16.983 13.643C16.56 16.013 14.492 17.813 12 17.813 9.51 17.813 7.44 16.013 7.017 13.643L1.682 14.977C1.28 15.077.873 14.833.773 14.432.673 14.03.917 13.623 1.319 13.522L6.979 12.108C7.264 9.86 9.019 8.074 11.25 7.743V3.75C11.25 3.336 11.586 3 12 3M13.824 11.361C12.622 11.214 11.407 11.213 10.205 11.358L10.295 12.102 10.385 12.847C11.466 12.717 12.56 12.717 13.642 12.85z"
            clipRule="evenodd"
          />
        </svg>
      }
    </span>
  )
}
export default AirportFilledIcon
